import { SpotStoreType } from '@/types/store/spot-store.type';

export const state: SpotStoreType = {
  spots: null,
  spot: null,
};
